import React from "react";

const TeamResultsSectionLoading: React.FC = () => {
  return (
    <div
      className="bg-white rounded-xl shadow-sm p-5 h-full flex flex-col items-center justify-center min-h-[280px] gap-4"
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <span
        className="inline-block w-10 h-10 border-2 border-[#3b519c] border-t-transparent rounded-full animate-spin"
        aria-hidden
      />
      <p className="text-[15px] font-primary text-[#6b7280] m-0">
        Loading team results…
      </p>
      <span className="sr-only">Loading team results</span>
    </div>
  );
};

export default TeamResultsSectionLoading;
